import { useCallback, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/typedReduxHooks'
import { setWorkPrescriberProfileId } from '../../../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import { SelectLocationModal } from './SelectLocationModal'
import { JoinLocationModal } from './JoinLocationModal'

export const InitLocationModal = () => {
  const [view, setView] = useState<'select' | 'join'>('select')

  const dispatch = useAppDispatch()
  const prescriber = useAppSelector((s) => s.prescriber.prescriber)
  const authentication = useAppSelector((s) => s.authentication)
  const workPrescriberProfileId = useAppSelector((s) => s.prescriber.workPrescriberProfileId)

  const isLoggedIn = Boolean(authentication?.userId)

  const prescriberName = useMemo(() => {
    if (!prescriber) return ''
    return `${prescriber.givenNames ?? ''} ${prescriber.familyName ?? ''}`.trim()
  }, [prescriber])

  const handleSelectLocation = useCallback(
    (prescriberProfileId: string) => {
      dispatch(setWorkPrescriberProfileId(prescriberProfileId))
    },
    [dispatch]
  )

  if (!isLoggedIn || workPrescriberProfileId) return null

  return (
    <>
      {view === 'select' && (
        <SelectLocationModal
          isOpen={true}
          prescriberName={prescriberName}
          title={prescriber?.title ?? ''}
          prescriberNumber={prescriber?.prescriberNumber ?? ''}
          onSelect={handleSelectLocation}
          onJoinNew={() => setView('join')}
        />
      )}
      {view === 'join' && (
        <JoinLocationModal
          isOpen={true}
          onClose={() => setView('select')}
          hideCloseButton={true}
          onBack={() => setView('select')}
        />
      )}
    </>
  )
}
